import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { SearchService } from './search.service';
import { MaterialModule } from '../shared/material/material.module';


@NgModule({
  declarations: [
    SearchComponent
  ],
  providers: [SearchService],
  imports: [
    CommonModule,
    SearchRoutingModule,
    MaterialModule
  ]
})
export class SearchModule { }
